import React from 'react';
import { FormattedMessage } from 'react-intl';
import { KeywordListProps } from 'models/KeywordListProps';
import {
  ButtonStyledCategory,
  Category
} from 'components/CategoryFilter/CategoryFilter.styles';
import { Context } from '@trustedshops/tps-seo-shared-frontend-react-components';
import {
  KeywordList as KeywordListStyled,
  KeywordListHeading
} from './KeywordList.styles';
import Link from 'next/link';
import { buildHref } from 'helpers/buildHref';

function KeywordList({ keywords, activeFilters }: KeywordListProps) {
  if (keywords.length === 0) {
    return null;
  }

  return (
    <KeywordListStyled>
      <KeywordListHeading as="div" $lookAlike="h3">
        <FormattedMessage id="SIMILAR_SEARCHES" />
      </KeywordListHeading>
      <Category>
        {keywords.map((keyword, index) => (
          <li key={index}>
            <Link
              href={buildHref({
                ...activeFilters,
                category: keyword.urlPath,
                keyword: undefined,
                page: undefined
              })}
            >
              <ButtonStyledCategory
                $context={Context.Tertiary}
                data-keyword={keyword.name}
              >
                <div className="categoryName">{keyword.name}</div>
              </ButtonStyledCategory>
            </Link>
          </li>
        ))}
      </Category>
    </KeywordListStyled>
  );
}

export default KeywordList;
